import type { Address, TokenId, Vault } from 'nftx.js';
import Erc20Input from './Erc20Input';
import Erc721Input from './Erc721Input';
import EthInput from './EthInput';
import { SwapType } from '@/domain/swap';

export default function SwapInput({
  source,
  network,
  amount,
  amountMax,
  token,
  type,
  dyadType,
  canChangeToken,
  symbol,
  fetching,
  vaultId,
  ethAmount,
  tokenIds,
  vault,
  onAmountChange,
  toggleSearch,
  onRemoveItem,
}: {
  source: 'wallet' | 'vault';
  network: number;
  type: SwapType;
  token: Address | '';
  amount: `${number}` | '';
  amountMax?: `${number}`;
  ethAmount?: bigint;
  dyadType: SwapType;
  canChangeToken: boolean;
  symbol: string;
  fetching: boolean;
  vaultId?: string;
  tokenIds?: `${number}`[];
  vault?: Pick<Vault, 'asset' | 'token' | 'tokenId'>;
  onAmountChange: (value: `${number}`) => void;
  toggleSearch: () => void;
  onRemoveItem: (tokenId: TokenId) => void;
}) {
  return (
    <div className="rounded-lg p-6 bg-gray-100 focus-within:border-gray-500/20 border border-transparent">
      {type === 'ETH' && (
        <EthInput
          source={source}
          network={network}
          amount={amount}
          amountMax={amountMax}
          canChangeToken={canChangeToken}
          dyadType={dyadType}
          symbol={symbol}
          fetching={fetching}
          vaultId={vaultId}
          ethAmount={ethAmount}
          onChange={onAmountChange}
          onSearchClick={toggleSearch}
        />
      )}
      {type === 'vTOKEN' && (
        <Erc20Input
          network={network}
          type={type}
          ethAmount={ethAmount}
          amount={amount}
          amountMax={amountMax}
          onChange={onAmountChange}
          token={token}
          source={source}
          dyadType={dyadType}
          symbol={symbol}
          fetching={fetching}
          vaultId={vaultId}
          canChangeToken={canChangeToken}
          onSearchClick={toggleSearch}
        />
      )}
      {type === 'NFT' && (
        <Erc721Input
          tokenIds={tokenIds}
          vault={vault}
          canChangeToken={canChangeToken}
          onSearchClick={toggleSearch}
          onRemoveItem={onRemoveItem}
        />
      )}
    </div>
  );
}
